import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/static/onboarding/biggest-planet.svg'
import _imports_1 from '../../../../assets/static/onboarding/smallest-planet.svg'
import _imports_2 from '../../../../assets/static/onboarding/astronaut.png'


const _withScopeId = n => (_pushScopeId("data-v-5ebc1e53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageBox = _resolveComponent("MessageBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MessageBox, {
      class: _normalizeClass(['layout__message', { reverse: _ctx.animationIsReverse }]),
      message: _ctx.message,
      facingRight: true,
      left: "20%"
    }, null, 8, ["class", "message"]),
    _createElementVNode("img", {
      class: _normalizeClass(['layout__biggest-planet', { reverse: _ctx.animationIsReverse }]),
      src: _imports_0,
      alt: "Planeta grande"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass(['layout__smallest-planet', { reverse: _ctx.animationIsReverse }]),
      src: _imports_1,
      alt: "Planeta pequeno"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass([
        'layout__astronaut',
        { 'fluctuate-facing-left': _ctx.isTransitionFinished },
        { reverse: _ctx.animationIsReverse }
      ]),
      src: _imports_2,
      alt: "Astronauta",
      onAnimationend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fluctuate && _ctx.fluctuate(...args)))
    }, null, 34),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      class: _normalizeClass(['layout__form', { reverse: _ctx.animationIsReverse }])
    }, [
      _createElementVNode("textarea", {
        value: _ctx.user.biography,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateUser($event.target))),
        tabindex: "2",
        class: "layout__input",
        rows: "4",
        cols: "4",
        placeholder: "Digite aqui"
      }, null, 40, _hoisted_2)
    ], 34)
  ]))
}